module.exports = __webpack_public_path__ + "img/shitang.de90dfa4.jpg";